import { keyDidAtom, refreshLocAtom, toggleCityAtom } from "./app";
import { homeAtom } from "./home";
import alertApi from "@/api/alertApi";
import {
  assignKeyDidToParams,
  assignResolvedKeyIdForSubPageQueries,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistSubpageApiInfoAndHeader,
} from "./utils/weatherQueryShared";

const alertDetailAtom = atom<any>([]);
const cityAtom = atom<any>({});
const queryAlertDetailAtom = atom(null, async (get, set, newParams: any) => {
  try {
    assignResolvedKeyIdForSubPageQueries(get, newParams, homeAtom);
    const refreshloc = get(refreshLocAtom);
    const toggleCity = get(toggleCityAtom);
    clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
    assignKeyDidToParams(newParams, get(keyDidAtom));

    const resData = await alertApi.query(newParams);
    resData?.data?.alertDetail?.length &&
      resData.data.alertDetail.forEach((item: any) => {
        item.isExpand = false;
      });

    const infoData = resData?.data?.info;
    persistSubpageApiInfoAndHeader(set, infoData);
    set(alertDetailAtom, resData?.data?.alertDetail || []);
    set(cityAtom, resData?.data?.city || {});
    return resData;
  } catch (error) {
    console.error("查询每日数据失败：", error);
    throw error;
  }
});

export { alertDetailAtom, queryAlertDetailAtom, cityAtom };
